<template>
  <div class="container">
    <button class="button is-info" @click="openCreateLinkModal">
      <span class="icon is-small">
        <i class="fas fa-plus"></i>
      </span>
      &nbsp;
      <span>Create Link</span>
    </button>
    <div class="wrapper">
      <table class="table is-striped is-fullwidth">
        <thead>
          <tr>
            <th class="is-hidden-mobile has-text-left">Campaign</th>
            <th class="is-hidden-tablet has-text-left">Link info</th>
            <th class="is-hidden-mobile has-text-left">Link</th>
            <th class="is-hidden-mobile has-text-left">Created at</th>
            <th class="is-hidden-mobile has-text-left">Visits</th>
            <th class="is-hidden-mobile has-text-left">Active</th>
            <th class="has-text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(obj, index) in links" :key="obj._id">
            <!--<td v-for="(prop, i) in obj" :key="i">{{prop}}</td>-->
            <td class="is-hidden-mobile">{{ obj.name }}</td>
            <td class="is-hidden-tablet">
              <div class="field">
                <strong>{{ obj.name }}</strong>
                <div class="control copy-link-switch mobile">
                  <input
                    :id="`mobile-${obj._id}`"
                    type="text"
                    class="input is-small"
                    readonly
                    :value="obj.link"
                  />
                </div>
                <strong>Created at:</strong>
                {{ $moment(obj.createdAt).fromNow() }}<br />
                <strong>Visits:</strong> {{ obj.totalVisits }}
              </div>
            </td>
            <td class="is-hidden-mobile">
              <div class="control copy-link-switch">
                <input
                  :id="`large-${obj._id}`"
                  type="text"
                  class="input"
                  readonly
                  :value="obj.link"
                />
                <button
                  type="button"
                  class="button is-info is-light is-fullwidth"
                  @click="copyText(obj.link, `large-${obj._id}`)"
                >
                  <span class="icon">
                    <i class="fas fa-copy"></i>
                  </span>
                  <span>Copy URL</span>
                </button>
              </div>
            </td>
            <td class="is-hidden-mobile">
              {{ $moment(obj.createdAt).fromNow() }}
            </td>
            <td class="is-hidden-mobile">{{ obj.totalVisits }}</td>
            <td class="is-hidden-mobile">
              <div class="field has-text-left">
                <input
                  :id="`switch-state-${index}`"
                  type="checkbox"
                  :name="`switch-state-${index}`"
                  class="switch is-rounded is-ltr"
                  :checked="obj.active"
                  @change="updateState($event, obj)"
                />
                <label :for="`switch-state-${index}`"></label>
              </div>
            </td>
            <td class="has-text-right">
              <div
                class="dropdown is-hoverable is-right"
                :class="{
                  'is-up': index === links.length - 1
                }"
              >
                <div class="dropdown-trigger">
                  <button
                    class="button is-rounded"
                    aria-haspopup="true"
                    :aria-controls="`dropdown-menu-${index}`"
                  >
                    <span class="icon">
                      <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                    </span>
                  </button>
                </div>
                <div
                  class="dropdown-menu has-text-left"
                  :id="`dropdown-menu-${index}`"
                  role="menu"
                >
                  <div class="dropdown-content">
                    <a :href="obj.link" class="dropdown-item">
                      <span class="icon">
                        <i class="fas fa-eye"></i>
                      </span>
                      <span>Open Link</span>
                    </a>
                    <a @click="linkToShare = obj" class="dropdown-item">
                      <span class="icon">
                        <i class="fas fa-share-square"></i>
                      </span>
                      <span>Share Link</span>
                    </a>
                    <a @click="embedLink = obj" class="dropdown-item">
                      <span class="icon">
                        <i class="fas fa-code"></i>
                      </span>
                      <span>Embed</span>
                    </a>
                    <a
                      @click="copyText(obj.link, `mobile-${obj._id}`)"
                      class="dropdown-item"
                    >
                      <span class="icon">
                        <i class="fas fa-copy"></i>
                      </span>
                      <span>Copy Link</span>
                    </a>
                    <a
                      class="dropdown-item"
                      :class="[
                        disableExport ? ['tooltip', 'is-tooltip-top'] : ''
                      ]"
                      @click="generateQR(obj)"
                      data-tooltip="Generate QR Code is a premium feature. Please upgrade your plan to gain access."
                    >
                      <span class="icon upgrade-text">
                        <i class="fas fa-qrcode"></i>
                      </span>
                      <span>Generate QR Code</span>
                      &nbsp;
                      <a v-if="disableQR" class="upgrade link">
                        <span class="icon">
                          <i class="fas fa-crown"></i>
                        </span>
                      </a>
                    </a>
                    <a
                      class="dropdown-item"
                      :class="[
                        disableExport ? ['tooltip', 'is-tooltip-top'] : ''
                      ]"
                      @click="exportVisits(obj)"
                      data-tooltip="Export Visits is a premium feature. Please upgrade your plan to gain access."
                    >
                      <span class="icon upgrade-text">
                        <i class="fas fa-file-csv"></i>
                      </span>
                      <span>Export Visits</span>
                      &nbsp;
                      <a v-if="disableExport" class="upgrade link">
                        <span class="icon">
                          <i class="fas fa-crown"></i>
                        </span>
                      </a>
                    </a>
                    <a
                      @click="
                        modal = true;
                        editMode = true;
                        link = JSON.parse(JSON.stringify(obj));
                        edit = index;
                      "
                      class="dropdown-item"
                    >
                      <span class="icon">
                        <i class="fas fa-sliders-h"></i>
                      </span>
                      <span>Settings</span>
                    </a>
                    <a
                      @click="openDeleteConfirmation(obj)"
                      class="dropdown-item has-background-danger has-text-light"
                    >
                      <span class="icon">
                        <i class="fas fa-trash-alt"></i>
                      </span>
                      <span>Delete Link</span>
                    </a>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <link-options
      :edit="editMode"
      :show="modal"
      :model="link"
      @close="clearLinkOptions"
    ></link-options>
    <confirmation
      @confirmDelete="deleteLink"
      @close="confirmationModal = false"
      :modal="confirmationModal"
      :toDelete="linkToDelete"
    ></confirmation>
    <!-- QR code modal -->
    <sdv-dialog v-model="generalModal">
      <template #header>
        <p class="modal-card-title">QR Code</p>
      </template>
      <template #footer>
        <button @click="generalModal = false" class="button is-info">
          Done
        </button>
      </template>
      <template>
        <div class="has-text-centered" v-html="qrCode"></div>
        <div class="has-text-centered">
          <a
            class="button is-primary is-small"
            download="qrcode.gif"
            :href="qrDataUrl"
            target="_blank"
          >
            <span class="icon is-small">
              <i class="fas fa-download"></i>
            </span>
            <span>Download</span>
          </a>
        </div>
      </template>
    </sdv-dialog>
    <!-- Share link  modal -->
    <share-link :link="linkToShare" @close="linkToShare = null" />
    <!-- Embed code modal -->
    <embed-link-modal :link="embedLink" @close="embedLink = null" />
  </div>
</template>
<script>
import qrcode from 'qrcode-generator';
import { copyText } from '@/utils/general';
export default {
  name: 'Links',
  props: ['model'],
  components: {
    LinkOptions: () => import('@/components/LinkOptions'),
    Confirmation: () => import('@/components/ConfirmationDelete'),
    SdvDialog: () => import('@/components/shared/SdvDialog'),
    ShareLink: () => import('@/components/ShareLink'),
    EmbedLinkModal: () => import('@/components/EmbedLinkModal')
  },
  watch: {
    model: function() {
      this.links = this.model;
    }
  },
  mounted() {
    // console.log("worker",PDFWorker);
    // PDFjs.GlobalWorkerOptions.workerSrc = PDFjs.PDFWorker;
    // If we are landing on the links tab and the openOptions parameter is true,
    // open the link options modal to create a new link automatically.
    if (this.$route.query.createLink) {
      this.openCreateLinkModal();
    }
  },
  data() {
    return {
      links: [],
      editMode: false,
      modal: false,
      link: {
        name: 'Default Campaign',
        props: '0',
        watermark: true,
        sharedWith: [],
        allowDownload: false,
        emailVerification: false,
        downloadNotifications: false,
        visitNotifications: false,
        whitelist: [],
        password: ''
      },
      edit: -1,
      show: false,
      confirmationModal: false,
      linkToDelete: {},
      generalModal: false,
      qrCode: '',
      qrDataUrl: '',
      linkToShare: null,
      embedLink: null
    };
  },
  computed: {
    disableExport() {
      let accessLevel = this.$store.getters['auth/getAccessLevel'];
      return (accessLevel && accessLevel.csvEmails.value !== true) || false;
    },
    disableQR() {
      let accessLevel = this.$store.getters['auth/getAccessLevel'];
      return (accessLevel && accessLevel.qrCode.value !== true) || false;
    }
  },
  methods: {
    /**
     * Opens the modal window to create a new link.
     */
    openCreateLinkModal() {
      this.modal = true;
      this.editMode = false;
      this.link.props = '0';
    },
    clearLinkOptions(data) {
      if (data && data.link) {
        if (this.edit === -1) {
          // Add a new link.
          this.links.push(data);
        } else {
          // Update an existing link.
          this.links[this.edit] = data;
        }
      }
      this.modal = false;
      this.editMode = false;
      this.link = {
        name: '',
        props: '0',
        watermark: true,
        sharedWith: [],
        allowDownload: false,
        emailVerification: false,
        downloadNotifications: false,
        visitNotifications: false,
        whitelist: [],
        password: ''
      };
      this.edit = -1;
    },
    /**
     * Opens the delete confirmation modal window.
     * @name openDeleteConfirmation
     * @param {Object} link - The link to be deleted.
     */
    openDeleteConfirmation(link) {
      this.linkToDelete = link;
      this.confirmationModal = true;
    },
    /**
     * Deletes a link permanently after confirmation.
     * @name deleteLink
     */
    deleteLink() {
      const linkName = this.linkToDelete.name;
      this.$axios
        .delete(`${this.$API.links()}${this.linkToDelete._id}`)
        .then(() => {
          this.$notify({
            group: 'alert',
            title: 'Deleted',
            text: `${linkName} has been deleted.`,
            type: 'success'
          });
          this.confirmationModal = false;
          this.linkToDelete = {};
          this.$emit('updated');
        })
        .catch(e => console.log(e));
    },
    openLink(link) {
      window.location = link;
    },
    /**
     * Executes the copy function to try and copy the text
     * to the clipboard. In case it fails, we need to enable
     * the input for manual interaction.
     * @param {String} text - The text to be copied
     * @param {String} elementId - The ID of the DOM element
     */
    copyText(text, elementId) {
      const clipboard = copyText(this);
      const promise = clipboard(text, elementId);
      promise.catch(err => {
        console.info('Error copying URL to clipboard: ', err);
        window.document.getElementById(elementId).classList.add('disable-copy');
      });
      // send event when a link is copied.
      this.$customerly.event('link_copied');
    },
    exportVisits(link) {
      if (this.disableExport) {
        return this.$router.push({ name: 'upgrade' });
      }
      let exportAllowed = this.$store.getters['auth/getAccessLevel']
        ? this.$store.getters['auth/getAccessLevel'].csvEmails.value
        : false;
      if (link.visits.length <= 0 || !exportAllowed) {
        return;
      }
      let visitsExported = [
        [
          'Owner Link',
          'Link Creation',
          'Link',
          'Visitor Email',
          'Visitor name',
          'Visit Date',
          'Was it downloaded?',
          'Total time spent'
        ]
      ];
      for (let i = 0; i < link.visits[0].times.length; i++) {
        visitsExported[0].push(`Time spent page ${i + 1}`);
      }
      link.visits.forEach(visit => {
        visit.times = visit.times.map(time => {
          return this.$moment()
            .startOf('day')
            .seconds(time)
            .format('H:mm:ss');
        });
        visitsExported.push(
          [
            this.$store.getters['auth/getUser'].name
              ? this.$store.getters['auth/getUser'].name
              : this.$store.getters['auth/getUser'].email,
            this.$moment(link.createdAt).format('MM/DD/YYYY'),
            link.link,
            visit.email,
            visit.name,
            this.$moment(visit.date).format('MM/DD/YYYY'),
            `${visit.downloaded ? 'Yes' : 'No'}`,
            this.$moment()
              .startOf('day')
              .seconds(visit.total)
              .format('H:mm:ss')
          ].concat(visit.times)
        );
      });
      let csvContent =
        'data:text/csv;charset=utf-8,' +
        visitsExported.map(e => e.join(',')).join('\n');
      let encodedUri = encodeURI(csvContent);
      let download = window.document.createElement('a');
      download.setAttribute('href', encodedUri);
      download.setAttribute('download', `${link.name}.csv`);
      window.document.body.appendChild(download);
      download.click();
    },
    /**
     * Generates a unique QR code for a Link.
     * @name generateQR
     * @param {Object} obj - The link object
     */
    generateQR(obj) {
      if (this.disableQR) {
        return this.$router.push({ name: 'upgrade' });
      }
      let qr = qrcode(0, 'L');
      qr.addData(obj.link);
      qr.make();
      this.qrDataUrl = qr.createDataURL();
      this.qrCode = qr.createImgTag();
      this.generalModal = true;
    },
    /**
     * Update link state.
     * @name updateState
     * @param {Object} evt - Event
     * @param {Object} obj - The link object
     */
    updateState(evt, link) {
      const data = {
        id: link._id,
        state: evt.currentTarget.checked
      };
      this.$axios
        .post(`${this.$API.links()}state`, data)
        .then(update => {
          const idx = this.links.findIndex(l => l._id === link._id);
          this.links[idx] = update;
          this.$notify({
            group: 'alert',
            title: 'Updated',
            text: `Link has been updated.`,
            type: 'success'
          });
        })
        .catch(e => {
          console.log(e);
          evt.currentTarget.checked = !evt.currentTarget.checked;
          this.$notify({
            group: 'alert',
            title: 'FAILED!',
            text: `Unable to update the link.`,
            type: 'success'
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.dropdown-content {
  .upgrade {
    color: inherit;
  }
}
</style>
